var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',_vm._g({class:_vm.variantCls.root,attrs:{"rows":_vm.rows,"disabled":_vm.disabled},domProps:{"value":_vm.value}},Object.assign({}, _vm.computedListeners,
		{input: function (event) { return _vm.$emit('input', event.target.value); }})))}
var staticRenderFns = []

export { render, staticRenderFns }